import { render, staticRenderFns } from "./boothOrderList.vue?vue&type=template&id=2495adcf&scoped=true"
import script from "./boothOrderList.vue?vue&type=script&lang=js"
export * from "./boothOrderList.vue?vue&type=script&lang=js"
import style0 from "./boothOrderList.vue?vue&type=style&index=0&id=2495adcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495adcf",
  null
  
)

export default component.exports